<template>
  <NuxtLayout name="activity">
    <div class="page-register w">
      <div
        v-if="!isSuccess"
        class="form_container"
      >
        <div class="head_top">
          <span class="title">注册账号</span>
          <span>已有账号，<NuxtLink to="/login"><span class="blue_text">立即登录 ></span></NuxtLink></span>
        </div>
        <el-form
          ref="formRef"
          :model="form"
          :rules="rules"
          size="large"
          class="form"
        >
          <el-form-item prop="telCode">
            <div class="prefix_select_input">
              <el-input
                v-model="form.phone"
                placeholder="请输入手机号"
              >
                <template #prefix>
                  <client-only>
                    <el-popover
                      ref="choosePop"
                      placement="bottom-start"
                      :width="336"
                      trigger="click"
                      :teleported="false"
                    >
                      <template #reference>
                        <span
                          class="c_333 pointer pop_holder"
                          @click="openPopver"
                        >
                          <span class="ellipsis">+{{ form.telCode }}</span>
                          <i class="arrows-bottom" />
                        </span>
                      </template>
                      <el-scrollbar>
                        <div class="te_code_enum">
                          <div
                            v-for="item in opts.TelCodeEnum"
                            :key="item.standardDesc"
                            class="te_code_enum_item"
                            @click="handleSelectTelCode(item)"
                          >
                            <span>
                              <span class="mgr10"> {{ item.codeDesc }}</span>
                              <span>{{ item.standardDesc }}</span>
                            </span>
                            <i
                              v-if="item.code + item.standardDesc === form.telCode + opts.country"
                              class="iconfont icon-correct blue font12"
                            />
                          </div>
                        </div>
                      </el-scrollbar>
                    </el-popover>
                  </client-only>
                </template>
              </el-input>
            </div>
          </el-form-item>
          <el-form-item prop="verificationCode">
            <el-input
              v-model="form.verificationCode"
              placeholder="短信验证码"
            >
              <template #prefix>
                <span class="iconfont icon-icon_Code" />
              </template>
              <template #suffix>
                <el-button
                  type="text"
                  @click="getCode"
                >
                  {{ txt }}
                </el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="loginPwd">
            <el-input
              v-model="form.loginPwd"
              type="password"
              show-password
              placeholder="密码由6-20位大写和小写字母和数字组成"
            >
              <template #prefix>
                <el-icon class="el-input__icon">
                  <lock />
                </el-icon>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="repeatPwd">
            <el-input
              v-model="opts.repeatPwd"
              type="password"
              show-password
              placeholder="确认密码"
            >
              <template #prefix>
                <el-icon class="el-input__icon">
                  <lock />
                </el-icon>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="form.isAgreement">
              我已阅读并同意<span
                class="blue_text"
                @click="openAgreementModel"
              >《用户协议》</span>
            </el-checkbox>
          </el-form-item>
        </el-form>
        <el-button
          class="submit"
          type="primary"
          @click="submitForm(formRef)"
        >
          注册
        </el-button>
      </div>
      <div
        v-else
        class="success_tips"
      >
        <img
          src="@/assets/images/success.png"
          alt=""
        >
        <div class="desc">
          注册成功
        </div>
        <p>{{ downtime }} 秒后自动跳转至登录页面</p>
        <el-button
          class="btn"
          type="primary"
          @click="toLogin"
        >
          立即登录
        </el-button>
      </div>
      <client-only>
        <agreement v-model="agreementModel.visible" />
      </client-only>
    </div>
  </NuxtLayout>
</template>
<script setup>
import { ElMessage } from 'element-plus'
import { Iphone, Lock } from '@element-plus/icons-vue'
import { useUserStore } from '@/stores/user'
import { getMsg, userRegister } from '@/api/user'
import cookie from '@/utils/cookies'
const cookieData = cookie.getShop()
useHead({
  title: '注册中心-' + cookieData.shopName
})
const agreementModel = reactive({
  visible: false
})
const openAgreementModel = () => {
  agreementModel.visible = true
}
const store = useUserStore()
const { getEnumList, setToken, getUserView } = store
const router = useRouter()

const opts = reactive({
  TelCodeEnum: '',
  country: '中国',
  repeatPwd: ''
})
const formRef = ref('')
const form = reactive({
  telCode: '86',
  phone: '',
  verificationCode: '',
  loginPwd: '',
  isAgreement: false
})

const checkPwd = (rule, value, callback) => {
  const passwordreg =
    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/
  if (!value) {
    return callback(new Error('请输入密码'))
  }
  if (!passwordreg.test(value) || value.length > 20 || value.length < 6) {
    callback(new Error('密码必须由6-20位大写和小写字母和数字组成'))
  } else {
    callback()
  }
}

const checkRepeatPwd = (rule, value, callback) => {
  if (!opts.repeatPwd) {
    return callback(new Error('请确认密码'))
  }
  if (opts.repeatPwd !== form.loginPwd) {
    callback(new Error('两次密码不一致'))
  } else {
    callback()
  }
}
const rules = reactive({
  telCode: [
    {
      required: true,
      message: '请选择国家/地区',
      trigger: 'change'
    }
  ],
  phone: [
    {
      required: true,
      message: '请输入手机号',
      trigger: 'blur'
    }
  ],
  verificationCode: [
    {
      required: true,
      message: '请输入验证码',
      trigger: 'blur'
    }
  ],
  loginPwd: [
    {
      validator: checkPwd,
      trigger: 'blur'
    }
  ],
  repeatPwd: [
    {
      validator: checkRepeatPwd,
      trigger: 'blur'
    }
  ]
})

onMounted(() => {
  getEnumList('TelCodeEnum', 'arr').then((res) => {
    opts.TelCodeEnum = res
  })
})
const choosePop = ref(null)
const openPopver = () => {
  const activeIndex = opts.TelCodeEnum.findIndex((item) => {
    return item.code + item.standardDesc === form.telCode + opts.country
  })
  const activeItem = opts.TelCodeEnum.splice(activeIndex, 1)
  opts.TelCodeEnum.unshift(activeItem[0])
}
const handleSelectTelCode = (row) => {
  form.telCode = row.code
  opts.country = row.standardDesc
  choosePop.value.hide()
}

// 获取系统信息
const getOsInfo = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  let name = 'Unknown'
  let version = 'Unknown'
  if (userAgent.indexOf('win') > -1) {
    name = 'Windows'
    if (userAgent.indexOf('windows nt 5.0') > -1) {
      version = 'Windows 2000'
    } else if (
      userAgent.indexOf('windows nt 5.1') > -1 ||
      userAgent.indexOf('windows nt 5.2') > -1
    ) {
      version = 'Windows XP'
    } else if (userAgent.indexOf('windows nt 6.0') > -1) {
      version = 'Windows Vista'
    } else if (
      userAgent.indexOf('windows nt 6.1') > -1 ||
      userAgent.indexOf('windows 7') > -1
    ) {
      version = 'Windows 7'
    } else if (
      userAgent.indexOf('windows nt 6.2') > -1 ||
      userAgent.indexOf('windows 8') > -1
    ) {
      version = 'Windows 8'
    } else if (userAgent.indexOf('windows nt 6.3') > -1) {
      version = 'Windows 8.1'
    } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows nt 10.0') > -1) {
      version = 'Windows 10'
    } else {
      version = 'Unknown'
    }
  } else if (userAgent.indexOf('iphone') > -1) {
    name = 'Iphone'
  } else if (userAgent.indexOf('mac') > -1) {
    name = 'Mac'
  } else if (
    userAgent.indexOf('x11') > -1 ||
    userAgent.indexOf('unix') > -1 ||
    userAgent.indexOf('sunname') > -1 ||
    userAgent.indexOf('bsd') > -1
  ) {
    name = 'Unix'
  } else if (userAgent.indexOf('linux') > -1) {
    if (userAgent.indexOf('android') > -1) {
      name = 'Android'
    } else {
      name = 'Linux'
    }
  } else {
    name = 'Unknown'
  }
  return {
    name,
    version
  }
}

const txt = ref('获取验证码')
const disabled = ref(false)
const timeOut = () => {
  let num = 60
  disabled.value = true
  txt.value = num
  const nt = setInterval(() => {
    if (num <= 0) {
      clearInterval(nt)
      disabled.value = false
      txt.value = '重新获取'
    } else {
      num--
      txt.value = num + 's'
    }
  }, 1000)
}

const getCode = () => {
  if (disabled.value) return
  if (!/^1\d{10,10}$/.test(parseInt(form.phone))) {
    ElMessage.error('请输入正确的手机号')
    return false
  }
  getMsg({
    phone: form.phone,
    telCode: form.telCode,
    verificationCodeType: 1
  }).then((res) => {
    timeOut()
  })
}

const isSuccess = ref(false)
const downtime = ref(5)
const submitForm = (formEl) => {
  const data = {}

  const { name: osName, version: osVersion } = getOsInfo()
  data.os = osName
  data.osVersion = osVersion
  if (!formEl) return
  formEl.validate((valid) => {
    if (valid) {
      if (!form.isAgreement) {
        ElMessage.error('请阅读并同意用户协议')
        return
      }
      userRegister({
        clientType: 1,
        ...form,
        ...data
      }).then((res) => {
        if (res) {
          isSuccess.value = true
          const timer = setInterval(() => {
            downtime.value -= 1
            if (downtime.value < 1) {
              clearInterval(timer)
              toLogin()
            }
          }, 1000)
        }
      })
    } else {
      return false
    }
  })
}
const toLogin = () => {
  router.push({ path: '/login' })
}
</script>
<style lang="scss">
.page-register {
  .el-select {
    width: 100%;
    .el-input__inner {
      text-align: right;
    }
  }
  .el-input__icon {
    color: #333;
  }
}
</style>
<style lang="scss" scoped>
.page-register {
  height: calc(100vh - 66px - 70px);
  display: flex;
  justify-content: center;
  align-items: center;
  .form_container {
    width: 440px;
    height: 490px;
    border-radius: 10px;
    background: #fff;
    padding: 30px;
    position: relative;
    .head_top {
      display: flex;
      justify-content: space-between;
      .title {
        font-size: 16px;
        font-weight: 700;
      }
    }
    .form {
      margin-top: 30px;
    }
    span {
      color: #333;
    }
    .submit {
      width: 100%;
      height: 50px;
    }
  }
  .success_tips {
    width: 680px;
    height: 460px;
    border-radius: 10px;
    background: #fff;
    padding: 70px 0;
    text-align: center;
    img {
      margin: auto;
    }
    .desc {
      font-size: 16px;
      margin-top: 20px;
    }
    p {
      color: #999;
      margin-top: 10px;
    }
    .btn {
      width: 380px;
      height: 50px;
      margin-top: 50px;
      font-size: 14px;
    }
  }
}
.blue_text {
  color: #2256F6 !important;
}

//修改选中后文本的颜色
:deep(.el-checkbox__input.is-checked+.el-checkbox__label){
  color:#333!important;
}
</style>
